import { MixedItem, RBRailSection } from 'store/railsBuilder/reducer.types';

import isCdvrRecordingItem from 'services/data-manager/parsing/utils/isCdvrRecordingItem';

import {
    BtvProgramme,
    CdvrRecording,
    DeeplinkRecommendation,
    EventItemWithServiceInfo,
    VodEditorial,
} from '../types';
import parseRBBtvProgrammeToMixedItem from './parseRBBtvProgrammeToMixedItem';
import parseRBChannelItemToMixedItem from './parseRBChannelItemToMixedItem';
import parseRBDeepLinkRecommendationToMixedItem from './parseRBDeepLinkRecommendationToMixedItem';
import parseRBVodEditorialToMixedItem from './parseRBVodEditorialToMixedItem';
import isBtvProgrammeItem from './utils/isBtvProgrammeItem';
import isDeeplinkRecommendationItem from './utils/isDeeplinkRecommendationItem';
import isEventItemWithServiceInfoItem from './utils/isEventItemWithServiceInfoItem';
import isVodEditorialItem from './utils/isVodEditorialItem';

function parseRailSection(section: RBRailSection) {
    const content: (MixedItem | CdvrRecording)[] = [];

    section.contents?.forEach(
        (
            railItem:
                | BtvProgramme
                | DeeplinkRecommendation
                | VodEditorial
                | EventItemWithServiceInfo
                | null,
        ) => {
            if (railItem) {
                if (isDeeplinkRecommendationItem(railItem)) {
                    const deepLinkItem =
                        parseRBDeepLinkRecommendationToMixedItem(railItem);

                    if (deepLinkItem) {
                        content.push(deepLinkItem);
                    }
                } else if (isEventItemWithServiceInfoItem(railItem)) {
                    content.push(parseRBChannelItemToMixedItem(railItem));
                } else if (isVodEditorialItem(railItem)) {
                    content.push(parseRBVodEditorialToMixedItem(railItem));
                } else if (isBtvProgrammeItem(railItem)) {
                    content.push(parseRBBtvProgrammeToMixedItem(railItem));
                } else if (isCdvrRecordingItem(railItem)) {
                    content.push(railItem);
                } else {
                    console.warn(
                        `[parseRailsSection.ts]: Unknown asset entityType`,
                        railItem,
                    );
                }
            }
        },
    );

    return content;
}

export default parseRailSection;
